module.exports = __webpack_public_path__ + "static/img/preview-04.4d20e888.webp";